const EDIT_OTHER_APPOINTMENT = "EDIT_OTHER_APPOINTMENT";
const DELETE = "DELETE";
const ADD_OTHER_APPOINTMENTS = "ADD_OTHER_APPOINTMENTS";
const ADD_OTHER_APPOINTMENT = "ADD_OTHER_APPOINTMENT";
const SET_SELECTED_OTHER_APPOINTMENT = "SET_SELECTED_OTHER_APPOINTMENT";

export {
    EDIT_OTHER_APPOINTMENT,
    DELETE,
    ADD_OTHER_APPOINTMENTS,
    ADD_OTHER_APPOINTMENT,
    SET_SELECTED_OTHER_APPOINTMENT,
};
